<mat-card data-at-firmware-update-modal *ngrxLet="firmwareUpdateStore.overallProgress$ as progress">
  <mat-card-header>
    <mat-card-title>
      {{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="flex flex-col items-center justify-center">
      <p>{{ 'GENERAL.LOADING' | translate }} ({{ progress }}%)</p>
      <vi-progress-bar-determine [value]="progress" [isLoading]="true"></vi-progress-bar-determine>
      <span>{{
        '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.LOADING.DESCRIPTION' | translate
      }}</span>
    </div>
  </mat-card-content>
</mat-card>
